import React from 'react';
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import Typography from '@mui/material/Typography';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';


import Header from "./common/Header2";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'animate.css';


const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  	...theme.typography.body2,
  	padding: theme.spacing(1),
  	textAlign: 'center',
  	color: theme.palette.text.secondary,
}));

function StartContent(props) {

  	let navigate = useNavigate(); 


	const callUrl = (url) => {
		navigate(url);
	};
	
	const [ref0, inView0] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref1, inView1] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const [ref2, inView2] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});	
	
	const [ref3, inView3] = useInView({
	    triggerOnce: true,
	    rootMargin: '0px 0px',
	});
	
	const hero = [ {
	  	"src": "Slide1HeroStartPage",
		"headline": "Impressum",
		"slogan": "Slogan fehlt hier"
		}
	];


  	return (<>
	  			<Box>
					<Header hero={hero} embedded={props.props.embedded} logo="logo.png"/>

	  			</Box>
				<Box sx={{ flexGrow: 1, display: {
							xs: 'block',
							sm: 'block',  
							md: 'block',  
							lg: 'block',  
							xl: 'block',  							
							} }}
				>

					
					<hr className="spacer"/>
	
		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'none',
																		sm: 'none',  
																		md: 'block',  
																		lg: 'block',  
																		xl: 'block',  																		
																		}}}> 
		      				<Grid container style={{paddingTop: "40px"}}>
		        				<Grid item xs={12}>
				      				<Grid container spacing={2}>
				        				<Grid item xs={1}>
					     	   			</Grid>		  				
										<Grid item xs={5}>		  				
							  				<Box sx={{paddingTop: "0px", marginTop: "40px"}}> 
												<div class='impressum'>
													<h1>Impressum</h1>
													<p>Angaben gemäß § 5 DDG</p>
													<p>Sabine Karst <br/> 
														Westallee  1<br/> 
														56112 Lahnstein <br/> 
													</p>
													<p> <strong>Vertreten durch: </strong><br/>
													Sabine Karst<br/>
													</p><p><strong>Kontakt:</strong> <br/>
														Telefon: +49-2621 188 079<br/>
														E-Mail: <a href='mailto:info@sabine-karst.de'>info@sabine-karst.de</a>
													<br/>
													</p>
													<p><strong>Umsatzsteuer-ID: </strong> <br/>
														Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz: 22 222 F81259<br/><br/>
														<br/>
														</p>
														<p><strong>Haftungsausschluss: </strong>
														<br/><br/>
														<strong>Haftung für Inhalte</strong><br/><br/>
														Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.<br/><br/><strong>Haftung für Links</strong><br/><br/>
														Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.<br/><br/><strong>Urheberrecht</strong><br/><br/>
														Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.<br/><br/><strong>Datenschutz</strong><br/><br/>
														Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. <br/>
														Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich. <br/>
														Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen. Die Betreiber der Seiten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-Mails, vor.<br/>
														</p>
														 </div>
											</Box>
										</Grid>
									</Grid>	
								</Grid>	
							</Grid>	
 			      		
						</Box>
	
		  				<Box sx={{paddingTop: "40px", paddingTop: "40px", display: {
																		xs: 'block',
																		sm: 'block',  
																		md: 'none',  
																		lg: 'none',  
																		xl: 'none',  																		
																		}}}> 
							<Box sx={{paddingTop: "0px"}}>
							</Box>	
		  				
Immobilienbewertung							
		  				
							

						</Box>
	
						
						<hr className="spacer"/>
		

		
	
	   				</Box>
   		</>
   	)
}

export default function StartPage(props) {

  return <StartContent props={props}/>;
}